<template>
    <div>
        <div class="mysmis-header">
            <div class="asistenta">
                <b-icon-info-circle-fill></b-icon-info-circle-fill>
                <span>Asistență/Manuale</span>
            </div>
            <div class="data">
                <b-icon-bell-fill></b-icon-bell-fill>
                <span><strong>Dată sistem:</strong> {{timestamp}}</span>
            </div>
            <div class="name">
                <span><strong>{{name}}</strong></span>
            </div>
            <div class="name">
                <span><strong>{{ business }}</strong></span>
            </div>
        </div>
        <div class="mysmis-breadcrumb">
            <ul class="breadcrumb-menu">
                <li class="active">Cereri de finanțare</li>
                <li>Contractare</li>
                <li>Achiziții</li>
                <li>Comunicare</li>
                <li>Implementare</li>
            </ul>
        </div>
        <div class="mysmis-breadcrumb2">
            <div class="page-title">
                <span>Identificatori proiect</span>
            </div>
            <div class="buttons">
                <div class="fullscreen">
                    <font-awesome-icon :icon="['fas', 'expand-arrows-alt']"></font-awesome-icon>
                </div>
                <div class="refresh">
                    <font-awesome-icon :icon="['fas', 'sync-alt']"></font-awesome-icon>
                </div>
                <div class="expand">
                    <font-awesome-icon :icon="['fas', 'arrows-alt-h']"></font-awesome-icon>
                </div>
            </div>
        </div>
        <div class="mysmis-info">
            <div class="project-info col-md-6">
                <b-form-group
                    id="fieldset-horizontal"
                    label-cols-sm="3"
                    label-cols-lg="2"
                    content-cols-sm
                    content-cols-lg="10"
                    label="Titlu proiect:"
                    label-for="input-horizontal"
                >
                    <b-form-input id="input-horizontal" v-model="projectName" readonly></b-form-input>
                </b-form-group>
                <p>Cod proiect: <span class="red">{{ projectCode }}</span></p>
            </div>
            <div class="project-details col-md-6">
                <p>Componentă 1 - Apel : POC/233/2/3/Consolidarea și asigurarea interoperabilității sistemelor informatice dedicate serviciilor de e-guvernare tip 2.0 centrate pe evenimente din viața cetățenilor și intreprinderilor, dezvoltarea cloud computing guvernamental și a comunicării media sociale, a Open Data si Big Data/3/Consolidarea și asigurarea interoperabilității sistemelor informatice dedicate serviciilor de e-guvernare tip 2.0 centrate pe evenimente din viața cetățenilor și intreprinderilor, dezvoltarea cloud computing guvernamental și a comunicării media sociale, a Open Data si Big Data</p>
            </div>
        </div>
        <router-view :allData="allData"></router-view>
    </div>
</template>

<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from '@fortawesome/fontawesome-svg-core'
import {faArrowsAltH} from '@fortawesome/free-solid-svg-icons'
import {faExpandArrowsAlt} from '@fortawesome/free-solid-svg-icons'
import {faSyncAlt} from '@fortawesome/free-solid-svg-icons'

library.add(faArrowsAltH, faExpandArrowsAlt, faSyncAlt)
import { BIconInfoCircleFill, BIconBellFill, BFormInput, BFormGroup } from "bootstrap-vue";
export default {
    components: {
        FontAwesomeIcon,
        BIconInfoCircleFill,
        BIconBellFill,
        BFormGroup,
        BFormInput,
    },
    data() {
        return {
            timestamp: '',
            name: '',
            business: JSON.parse(localStorage.getItem('currentM3Company')).name,
            projectName: '',
            projectCode: '',
        }
    },
    computed: {
        allData() {
            return this.$store.getters['m3Sketch/allData']
        }
    },
    mounted() {

        this.name = this.$store.state.auth.user.name
        if(this.allData.m3_project.mysmis) {
            this.projectName = this.allData.m3_project.mysmis.title
            this.projectCode = this.allData.m3_project.mysmis.code
        }
    },
    created() {
        setInterval(this.getNow, 1000);
    },
    methods: {
        getNow: function() {
            const today = new Date();
            const date = today.getDate()+'/'+(today.getMonth()+1)+'/'+today.getFullYear();
            const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            const dateTime = time +' '+ date;
            this.timestamp = dateTime;
        }
    }
}
</script>

<style scoped>
.mysmis-header{
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}
.asistenta{
    display: flex;
    align-items: center;
    color: #0072C6;
    font-size: 12px;
}
.data{
    display: flex;
    align-items: center;
    color: #0072C6;
    font-size: 12px;
    min-width: 200px;
}
.name{
    color: #0072C6;
    font-size: 12px;
}
.asistenta svg{
    margin-right: 5px;
}
.data svg{
    color: #53a93f;
    margin-right: 5px;
    animation: ring 2s ease infinite;
}
@-webkit-keyframes ring {
    0% { -webkit-transform: rotateZ(0); }
    1% { -webkit-transform: rotateZ(8deg); }
    3% { -webkit-transform: rotateZ(-10deg); }
    5% { -webkit-transform: rotateZ(12deg); }
    7% { -webkit-transform: rotateZ(-14deg); }
    9% { -webkit-transform: rotateZ(12deg); }
    11% { -webkit-transform: rotateZ(-10deg); }
    13% { -webkit-transform: rotateZ(11deg); }
    15% { -webkit-transform: rotateZ(-12deg); }
    17% { -webkit-transform: rotateZ(11deg); }
    19% { -webkit-transform: rotateZ(-10deg); }
    21% { -webkit-transform: rotateZ(9deg); }
    23% { -webkit-transform: rotateZ(-8deg); }
    25% { -webkit-transform: rotateZ(7deg); }
    27% { -webkit-transform: rotateZ(-6deg); }
    29% { -webkit-transform: rotateZ(5deg); }
    31% { -webkit-transform: rotateZ(-4deg); }
    33% { -webkit-transform: rotateZ(3deg); }
    35% { -webkit-transform: rotateZ(-4deg); }
    37% { -webkit-transform: rotateZ(2deg); }
    39% { -webkit-transform: rotateZ(-1deg); }
    41% { -webkit-transform: rotateZ(1deg); }

    43% { -webkit-transform: rotateZ(0); }
    100% { -webkit-transform: rotateZ(0); }
}
.mysmis-breadcrumb{
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0072c6;
    border-top: 2px solid black;
    margin-top: 10px;
}
.breadcrumb-menu{
    width: 60%;
    display: flex;
    height: 100%;
    margin: 0;
}
.breadcrumb-menu li{
    min-height: 40px;
    padding: 0 16px 0 7px;
    font-size: 13px;
    color: #fff;
    display: flex;
    align-items: center;
    font-family: Arial;
    cursor: pointer;
}
.breadcrumb-menu li:hover{
    background: #ffa101;
}
.breadcrumb-menu .active{
    background: #ffa101;
}
.mysmis-breadcrumb2{
    position: relative;
    width: 100%;
    max-height: 40px;
    border-bottom: 2px solid black;
    background: #f3f3f3;
}
.page-title{
    font-size: 15px;
    font-weight: 600;
    padding: 5px;
}
.buttons{
    position: absolute;
    bottom: -3px;
    right: 20px;
    display: flex;
    gap: 10px;
}
.fullscreen{
    padding: 0 7px;
    color: #fb6e52;
    border-bottom: 3px solid #fb6e52;
}
.refresh{
    padding: 0 7px;
    color: #ffce55;
    border-bottom: 3px solid #ffce55;
}
.expand{
    padding: 0 7px;
    color: #2dc3e8;
    border-bottom: 3px solid #2dc3e8;
}
.mysmis-info{
    display: flex;
    background-color: #fbfbfb;
    color: #262626;
    padding: 10px 0;
}
.project-info >>> input{
    font-size: 12px;
    border-radius: 0;
    background: transparent;
}
.project-info >>> label{
    font-size: 12px;
    padding: 0;
    padding-left: 10px;
    font-weight: 600;
}
.project-info .form-group{
    margin-bottom: 15px;
}
.project-info p{
    font-weight: 600;
    color: #262626;
}
.red{
    color: #b40000;
}
.project-details p{
    font-size: 11px;
    line-height: 1.3;
}
</style>
